import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDownRight, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

const TONES = {
  green: "bg-success/10 text-success",
  terracotta: "bg-accent/10 text-accent",
  danger: "bg-danger/10 text-danger",
  gold: "bg-warning/15 text-[hsl(41_60%_32%)]",
  slate: "bg-chart-3/10 text-chart-3",
};

export default function KpiCard({ to, onClick, active, icon: Icon, tone = "green", label, value, trendPct, sublabel, sublabelTone, testId }) {
  const positive = (trendPct || 0) >= 0;
  const Wrapper = to ? Link : onClick ? "button" : "div";
  const interactive = Boolean(to || onClick);
  return (
    <Wrapper
      to={to}
      onClick={onClick}
      type={onClick && !to ? "button" : undefined}
      aria-pressed={onClick ? Boolean(active) : undefined}
      data-testid={testId}
      className={`group flex items-center gap-3.5 bg-card border border-border rounded-2xl p-4 2xl:p-5 shadow-[0_1px_2px_rgba(42,33,29,0.04)] text-left w-full ${interactive ? "hover:border-primary/30 hover:shadow-md" : ""} ${active ? "border-primary ring-1 ring-primary/30" : ""} transition-all hi-animate-fade-up`}
    >
      <span className={cn("h-11 w-11 rounded-full flex items-center justify-center shrink-0", TONES[tone])}>
        <Icon className="h-5 w-5" strokeWidth={1.75} />
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-[11px] font-semibold tracking-wider text-muted-foreground uppercase truncate">{label}</p>
        <p className="font-serif text-3xl text-foreground mt-0.5 leading-tight">{value}</p>
        {trendPct != null ? (
          <p className={cn("mt-1 text-xs flex items-center gap-1 whitespace-nowrap", positive ? "text-success" : "text-danger")}>
            {positive ? <ArrowUpRight className="h-3.5 w-3.5" /> : <ArrowDownRight className="h-3.5 w-3.5" />}
            {positive ? "+" : "−"}
            {Math.abs(trendPct)}% vs last month
          </p>
        ) : (
          <p className={cn("mt-1 text-xs font-medium", sublabelTone || "text-muted-foreground")}>{sublabel}</p>
        )}
      </div>
      {interactive && (
        <ChevronRight className="h-4 w-4 text-muted-foreground group-hover:text-foreground group-hover:translate-x-0.5 transition-all shrink-0" />
      )}
    </Wrapper>
  );
}
